// extracted by mini-css-extract-plugin
export default {"formInputBox":"index_formInputBox_NFn4C","formInput":"index_formInput_Zt4lg","formInputSmall":"index_formInputSmall_OdaSq"};